import type { SignInStepName } from './types'

// Following Register pattern exactly
export type FieldsForStep = Readonly<Record<SignInStepName, ReadonlyArray<string>>>

export const fieldsForStep: FieldsForStep = {
  signin: ['username', 'password', 'rememberMe'],
  'help-panel': [],
  'forgot-username-confirmation': [],
  'forgot-password-reset-link': [],
  'forgot-password-reset-form': ['newPassword', 'confirmPassword'],
  'forgot-password-confirmation': [],
  'login-success': [],
  'account-locked': [],
} as const
